// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1qHC9","right":"Footer_right__3Bdub","buttons":"Footer_buttons__2aVSu"};